import * as _ from 'lodash-es';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import Logger from './Logger';
import { isElectron } from './desktopClient';
import intercomFacade from './intercomFacade';

const ORGANIZATION_FRAGMENT = gql(`
  fragment initAnalytics_organization on Organization {
    id
    host
    planTier
    insertedAt
    subscriptionId
  }
`);

const USER_FRAGMENT = gql(`
  fragment initAnalytics_user on User {
    id
    name
    email
    title
    type
    settings {
      allowAccountAccess
    }
    avatar {
      original
    }
    insertedAt
  }
`);

export function initAnalytics(
  organization: DocumentType<typeof ORGANIZATION_FRAGMENT>,
  user: DocumentType<typeof USER_FRAGMENT>,
  intercomHash: string,
) {
  const { analytics } = window;
  try {
    const companyInfo = {
      id: organization.id,
      host: organization.host,
      plan: _.toLower(organization.planTier ?? ''), // plan has special meaning in Intercom
      createdAt: organization.insertedAt,
      subscriptionId: organization.subscriptionId ?? null,
    };
    const userInfo = {
      id: user.id,
      name: user.name,
      email: user.email,
      title: user.title,
      type: _.toLower(user.type ?? ''),
      createdAt: user.insertedAt,
      company: companyInfo,
    };

    intercomFacade.identify(
      {
        ...userInfo,
        allowAccountAccess: user.settings?.allowAccountAccess ?? false,
        avatar: user.avatar?.original ?? null,
      },
      intercomHash,
    );
    analytics.identify(user.id, userInfo, {
      ...(isElectron
        ? {
            context: {
              app: {
                name: 'Slab',
                version: window.desktop?.version || '',
              },
            },
          }
        : undefined),
    });

    analytics.group(organization.id, companyInfo);
  } catch (e) {
    Logger.error(e, { source: 'segment analytics.js context' });
  }
}

export function track(...args: unknown[]) {
  window.analytics.track(...args);
}
